import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface WorkspaceChangeConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  onCancel: () => void
  projectCount?: number
  taskCount?: number
  userCount?: number
  usersLabel?: string
  description?: string
}

/**
 * Reusable dialog for confirming workspace changes when associations exist
 * Shows a warning and lists current associations that will be affected
 */
export function WorkspaceChangeConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  projectCount = 0,
  taskCount = 0,
  userCount = 0,
  usersLabel = 'user',
  description,
}: WorkspaceChangeConfirmDialogProps) {
  const defaultDescription =
    'Changing the workspace will clear all current associations. This action cannot be undone.'

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Change Workspace?</DialogTitle>
          <DialogDescription>{description || defaultDescription}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">Current associations:</p>
          <ul className="text-sm space-y-1 list-disc list-inside">
            {userCount > 0 && (
              <li>
                {userCount} {usersLabel}
                {userCount !== 1 ? 's' : ''}
              </li>
            )}
            {projectCount > 0 && (
              <li>
                {projectCount} project{projectCount !== 1 ? 's' : ''}
              </li>
            )}
            {taskCount > 0 && (
              <li>
                {taskCount} task{taskCount !== 1 ? 's' : ''}
              </li>
            )}
          </ul>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>Change Workspace</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
